import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=93a9b514&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a9b514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93a9b514')) {
      api.createRecord('93a9b514', component.options)
    } else {
      api.reload('93a9b514', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=93a9b514&scoped=true&", function () {
      api.rerender('93a9b514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/henpin/detail.vue"
export default component.exports